<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form action="" method="post" class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Frase</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="phrase"
                        class="form-control"
                        placeholder="Frase"
                    />
                    <span v-if="allerrors.phrase" :class="['show-error']">{{
                        allerrors.phrase[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            title: null,
            phrase: null,
            allerrors: {
                title: null,
                phrase: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contest-sections?section=premios&contest_id=" + me.model_id)
                .then(function (response) {
                    me.title = response.data.title;
                    me.phrase = response.data.phrase;
                    me.clearError();
                })
                .catch(function (error) {});
        },
        update() {
            let me = this;
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;
            if (me.validForm()) {
                axios
                    .put(`/api/contest-sections?section=premios&contest_id=${me.model_id}&key=${authUserId}`, {
                        phrase: me.phrase,
                        title: me.title,
                    })
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo título es obligatorio."];
                valid = false;
            } else if (me.title.length > 100) {
                me.allerrors.title = [
                    "El campo título debe tener máximo 100 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = null;
            }

            if (!me.phrase) {
                me.allerrors.phrase = ["El campo frase es obligatorio."];
                valid = false;
            } else if (me.phrase.length > 100) {
                me.allerrors.phrase = [
                    "El campo frase debe tener máximo 100 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.phrase = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                phrase: null,
            };
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
    },
    mounted() {
        let me = this;
        me.getModel();
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
